/* Progressive enhancement: native scroll and thumbnail anchors work without JS. */
(() => {
  if (customElements.get('vp-product-gallery')) return;
  customElements.define('vp-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.vpReady) return;
      this.vpReady = true;
      this.track = this.querySelector('[data-vp-track]');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.thumbs = Array.from(this.querySelectorAll('[data-vp-to]'));
      this.counter = this.querySelector('[data-vp-counter]');
      this.previous = this.querySelector('[data-vp-prev]');
      this.next = this.querySelector('[data-vp-next]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.index = 0;
      this.go = (index) => {
        const target = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reduced() ? 'auto' : 'smooth' });
      };
      this.sync = () => {
        const width = this.track.clientWidth;
        if (!width) return;
        this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
        this.thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
        this.slides.forEach((slide, i) => { if (i !== this.index) slide.querySelectorAll('video').forEach(video => video.pause()); });
        const label = `${this.index + 1} / ${this.slides.length}`;
        if (this.counter && this.counter.textContent !== label) this.counter.textContent = label;
        if (this.previous) this.previous.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      };
      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', event => { event.preventDefault(); this.go(i); }, options));
      if (this.previous) this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(this.sync); }, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, options);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => { this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'auto' }); this.sync(); });
        this.observer.observe(this.track);
      }
      this.querySelector('[data-vp-controls]')?.removeAttribute('hidden');
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.vpReady = false; }
  });
})();
